import { render } from "./apply.vue?vue&type=template&id=7fa8d24b"
const script = {}

import exportComponent from "D:\\phpStudy\\WWW\\WeCom\\enterprise-wechat---test\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__